import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { IVerticalMenu } from '../../invoicing-module/shared/IVerticalMenu.interface';
import { Router } from '@angular/router';
import { ModulesService } from 'src/app/services/modules.service'; // adjust path as needed

@Component({
  selector: 'app-vertical-bar',
  templateUrl: './vertical-bar.component.html',
  styleUrls: ['./vertical-bar.component.scss'],
})
export class VerticalBarComponent {


  constructor(private modulesService: ModulesService) { }


  @Input() isMenuVisible: boolean;

  public isParentExpanded = false
  public isChildParentExpanded = false;
  public expandedChildParentName: string;
  public expandedParentName: string;

  private readonly router = inject(Router);

  @Input()
  menu!: IVerticalMenu[];

  @Output()
  moduleSelected = new EventEmitter<string>();



  @Output() toggleMenu = new EventEmitter<boolean>();

  collapseMenu() {
    this.toggleMenu.emit(false);
  }


  onParentExpand(e: MouseEvent, menuItem) {
    if (!menuItem.children) {
      this.router.navigate(['/' + menuItem.route]);
    }
    this.modulesService.setModuleName(menuItem.name);

    const isChild = (e.target as HTMLElement).classList.contains('no-close');
    if (!isChild && this.expandedParentName === menuItem.name) {
      this.isChildParentExpanded = false;
      this.expandedParentName = undefined;
      this.expandedChildParentName = undefined;
      this.isChildParentExpanded = false;
      return;
    }
    if (this.expandedParentName !== menuItem.name) {
      this.expandedChildParentName = undefined;
      this.isChildParentExpanded = false;
    }
    this.expandedParentName = menuItem.name;
    this.isParentExpanded = true;
    return;
  }

  onChildParentExpand(e: MouseEvent, child) {
    const isChild = (e.target as HTMLElement).classList.contains('child');
    if (isChild && this.expandedParentName === child.name) {
      return;
    }
    if (!isChild && this.expandedChildParentName === child.name) {
      this.expandedChildParentName = undefined;
      this.isChildParentExpanded = false;
      return;
    }
    this.expandedChildParentName = child.name;
    this.isChildParentExpanded = true;
    return;
  }

  onChildNavigate(child: IVerticalMenu) {
    if (child.queryParam === 0 || child.queryParam) {
      const queryParams: { [key: string]: any } = {
        formId: child.queryParam,
        ...child.queryParams
      };
      this.router.navigate(['/forms-table'], { queryParams });
    } else if (child.queryParams) {
      this.router.navigate(['/' + child.route], { queryParams: child.queryParams });
    } else {
      this.router.navigate(['/' + child.route]);
    }

    this.isParentExpanded = false;
    this.expandedParentName = undefined;
  }
}
